function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
// import {validation} from '@signiapp/helpers';
import { PhoneNumberUtil } from 'google-libphonenumber';
import validator from 'validator';
import { t } from "../../helpers/i18n";
var phoneUtil = PhoneNumberUtil.getInstance();
export var validators = {
  email: function email(data) {
    var _sms_otp$;
    var sms_otp = data.signatureMethods.filter(function (signatureMethods) {
      return signatureMethods.idp === 'sms_otp';
    });
    if (!data.email && !data.mobileNumber && ((_sms_otp$ = sms_otp[0]) === null || _sms_otp$ === void 0 ? void 0 : _sms_otp$.idp) != 'sms_otp') {
      return {
        errors: [t('recipient_validation_email_or_mobilenumber_is_required')]
      };
    }
    if (!data.email && data.mobileNumber) {
      return;
    }
    if (data !== null && data !== void 0 && data.email && validator.isEmail(data === null || data === void 0 ? void 0 : data.email) === false) {
      return {
        errors: [t('recipient_validation_invalid_email')]
      };
    }
  },
  mobileNumber: function mobileNumber(data) {
    var _sms_otp$2, _sms_otp$3, _mobileNumber;
    var sms_otp = data.signatureMethods.filter(function (signatureMethods) {
      return signatureMethods.idp === 'sms_otp';
    });
    if (!data.email && !data.mobileNumber && ((_sms_otp$2 = sms_otp[0]) === null || _sms_otp$2 === void 0 ? void 0 : _sms_otp$2.idp) != 'sms_otp') {
      return {
        errors: [t('recipient_validation_mobilenumber_or_email_is_required')]
      };
    } else if (((_sms_otp$3 = sms_otp[0]) === null || _sms_otp$3 === void 0 ? void 0 : _sms_otp$3.idp) == 'sms_otp' && !(data !== null && data !== void 0 && data.mobileNumber)) {
      return {
        errors: [t('recipient_validation_mobileNumber_mandatory_with_sms_otp')]
      };
    }
    if (!data.mobileNumber) {
      return;
    }
    var mobileNumber;
    var mobileIsValid;
    try {
      mobileNumber = phoneUtil.parseAndKeepRawInput(data.mobileNumber || '', 'NO');
      mobileIsValid = phoneUtil.isValidNumber(mobileNumber);
    } catch (err) {
      mobileIsValid = false;
    }
    if (mobileIsValid === false) {
      return {
        errors: [t('recipient_validation_invalid_mobilenumber')]
      };
    }

    // Means country code was not determined from input value
    if (((_mobileNumber = mobileNumber) === null || _mobileNumber === void 0 ? void 0 : _mobileNumber.getCountryCodeSource()) !== 1) {
      return {
        errors: [t('recipient_validation_mobilenumber_countrycode_is_required')]
      };
    }
  },
  signatureMethods: function signatureMethods(data, order) {
    if (order.advanced.stack === 'green') {
      var _data$signatureMethod;
      if (!((_data$signatureMethod = data.signatureMethods) !== null && _data$signatureMethod !== void 0 && _data$signatureMethod.length)) {
        return {
          errors: [t('recipient_validation_signing_method_is_required')]
        };
      }
    } else if (order.advanced.stack === 'blue') {
      var anySignerHasPki = order.signers.find(function (signer) {
        return signer.data.signatureMethods.find(function (signatureMethod) {
          return signatureMethod.signMechanism === 'pki_signature';
        });
      });
      if (anySignerHasPki && data.signatureMethods.length === 0) {
        return {
          errors: [t('recipient_validation_signing_method_is_required')]
        };
      }
    }
  }
};
var signer = function signer(data, order) {
  return Object.entries(validators).reduce(function (acc, curr) {
    var _curr = _slicedToArray(curr, 2),
      key = _curr[0],
      val = _curr[1];
    // const result = val(data[key]);
    var result = val(data, order);
    return result ? _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, result)) : acc;
  }, {});
};
export default signer;